<template>
  <div v-if="can('edit-user')">
    <h2>Edit Staff</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider name="title" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="name">Name<Astrik /></label>
              <input
                type="text"
                v-model="name"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="email">Email<Astrik /></label>
              <input
                type="text"
                v-model="email"
                class="form-control"
                id="email"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider name="sort" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Sort<Astrik /></label>
              <input
                type="text"
                v-model="sort"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="status"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="title">Status<Astrik /></label>
              <select class="form-select" v-model="status">
                <option
                  :value="status.value"
                  v-for="(status, index) in $store.state.status"
                  :key="index"
                >
                  {{ status.label }}
                </option>
              </select>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Submit</button>
            <router-link
              class="text-decoration-none btn btn-danger pull-right"
              :to="{
                name: 'UserList',
              }"
            >
              Cancel
            </router-link>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddUser",
  data() {
    return {
      users: [],
      loading: false,
      submitting: false,
      name: "",
      email: "",
      sort: 1,
      status: 1,
    };
  },
  mounted() {
    // if (this.can("edit-user")) {
    this.getUserDetail();
    // } else {
    //   this.$router.push({ name: "Dashboard" });
    // }
  },
  methods: {
    onSubmit() {
      this.submitting = true;
      const formData = new FormData();
      formData.append("_method", "PATCH");
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("status", this.status);
      formData.append("sort", this.sort);
      this.$http
        .post("user/" + this.$route.params.id, formData)
        .then((res) => {
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "User",
              type: "success",
              text: res.data.message,
            });
            this.$router.push({
              name: "UserList",
            });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    getUserDetail() {
      this.$http
        .get("user/" + this.$route.params.id)
        .then((res) => {
          if (res.data.status == 1) {
            this.name = res.data.data.name;
            this.email = res.data.data.email;
            this.sort = res.data.data.sort;
            this.status = res.data.data.status;
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
